import React from 'react'
import { Link } from 'react-router-dom' 
import LazyLoad from 'react-lazyload';
const FooterMun = () => {
  const currentYear = new Date().getFullYear(); 
  return (
    <>
    <div className="footer" id="contact" style={{padding: "30px 0 0"}}>  
       
      <div className="container-fluid fulwidth">
        <div className="row">
            <div className="col-xl-3 col-lg-12 col-md-12 ">
            <LazyLoad>  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/ftr-logo.png" class="img-fluid ftr-logo" alt="Nirmala Convent School, Rajkot" /></LazyLoad>
                <p>Nirmala proudly takes the responsibility of providing quality education and formation to more than 3450 girls.</p>
                <div className='social_media'>
                  <ul>
                    <li><a href="#" target="_blank"><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/twitter.png" alt="Nirmala Convent School, Rajkot" /></LazyLoad></a></li>
                    <li><a href="https://www.instagram.com/nirmalaconventrajkot?igsh=MWxobHVkNmh3MHp4aw==" target="_blank"><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/insta.png" alt="Nirmala Convent School, Rajkot" /></LazyLoad></a></li>
                    <li><a href="https://www.facebook.com/NirmalaConventRajkot/" target="_blank"><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/facebook.png" alt="Nirmala Convent School, Rajkot" /></LazyLoad></a></li> 
                  </ul>
                </div>
            </div>
            {/* <div className="col-xl-3 col-lg-6 col-md-6 divider">
                <div className="quick-link">
                  <h5>Quick links</h5>
                    <ul>
                        <li><Link to="/kindergarten"> <i className="bi bi-caret-right-fill"></i> Kindergarten</Link></li> 
                        <li><Link to="/cbse"> <i className="bi bi-caret-right-fill"></i> CBSE Board </Link></li> 
                        <li><Link to="/erp-software"> <i className="bi bi-caret-right-fill"></i> ERP Software </Link></li>
                        <li><Link target='_blank' to="https://portalguidelines.campuscare.info/index.html#NCSRAJ"> <i className="bi bi-caret-right-fill"></i> Portal (Help)? </Link></li>                     
                        <li><Link to="/"> <i className="bi bi-caret-right-fill"></i>  Sitemap</Link></li>
                        <li>
                       
                                  <Link to="/coming-soon">
                           <i className="bi bi-caret-right-fill"></i> Clubs</Link></li> 
                    </ul>
                </div>
                <div className="cont-dtl">
                    <h5>Our Location</h5>
                    <p><Link to="https://maps.app.goo.gl/7gxj29hJd1ZiCZFi9" target="_blank"><i className="bi bi-geo-alt"></i> Nirmala Convent Rd, Kailash Nagar, Rajkot, Gujarat 360 007</Link></p>
                    <p><Link to="tel:0281-2966204"><i className="bi bi-telephone-fill"></i> 0281-2966204 / 03</Link></p> 
                    <p><Link to="mailto:ncsrajkot@gmail.com"><i class="bi bi-envelope-fill"></i> ncsrajkot@gmail.com</Link></p> 
                    <p><Link to="mailto:nirmala.mun@nirmalaconventschool.org">nirmala.mun@nirmalaconventschool.org</Link></p>
                </div>
            </div>  */}
            <div className="col-xl-9 col-lg-12 col-md-12">
              <div className="d-flex footer-wrap">
                <div className="row w-100 g-4">
                  <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                    <div className="cont-dtl h-100">
                      <h5>NCS MUN CONTACT DETAILS</h5>
                      <p>
                        <Link to="tel:+919937563612">
                          <i className="bi bi-telephone-fill"></i> (+91) 99375 63612
                        </Link>
                        <br />
                        <Link to="tel:+918141283903">
                          (+91) 81412 83903
                        </Link>
                      </p>
                      <p>
                        <Link to="mailto:nirmala.mun@nirmalaconventschool.org">
                          <i className="bi bi-envelope-fill"></i> nirmala.mun@nirmalaconventschool.org
                        </Link>
                      </p>
                    </div>
                  </div>

                  <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                    <div className="cont-dtl h-100">
                      <h5>MUN SCHEDULE</h5>
                      <p>
                        <i className="bi bi-alarm-fill"></i> Day 1 Timings - 9:00 am to 5:30 pm
                        <br />
                        Day 2 Timings - 9:00 am to 7:30 pm
                        <br />
                        Event Date - 17/7/26 &amp; 18/7/26
                      </p>
                    </div>
                  </div>

                  <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="cont-dtl h-100">
                      <h5>REGISTRATION FORM</h5>
                      <div className="footerbtm">
                        <div className="mobile-app">
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/qr_Code_MUN_ncs.png"
                            style={{ width: "175px" }}
                            alt="NCS MUN Registration Form QR Code"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

               
                </div>
              </div>
            </div>
        </div>
       </div> 
       <div className="copyright">
          <p>©️Copyright 2020 - {currentYear} Nirmala Convent School, Rajkot. All right reserved </p> 
      </div>
    </div> 
    </>
  )
}

export default FooterMun
